<template>
	<div>
		<div class="navbar-ceil row border-bottom">
			<nav class="navbar navbar-static-top">

				<div class="navbar-title">
					<img @click.stop.prevent="$router.push('/cgd/by/index')" src="../../../common/assets/img/sjtu.png"
					     alt="neobay"/>
					<div class="banner-title">
						{{$store.state.appName}}后台
					</div>
				</div>

				<div class="navbar-header">
					<button class="btn btn-success " @click.stop.prevent="toggleMinimize">
						<i class="fa fa-bars"></i>
					</button>
				</div>
				<ul class="nav navbar-right">
					<li>
						<router-link to="/cgd/by/user/login">
							<i class="fa fa-sign-out"></i> 退出
						</router-link>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>
<script>
	import {mapActions} from 'vuex'

	export default {
		data () {
			return {}
		},
		methods: {
			...mapActions([
				'toggleMinimize'
			])
		}
	}
</script>



// WEBPACK FOOTER //
// TopNavBar.vue?0ed2b142